/* global window */
import { get } from 'lodash';
import Types from './Types';
import { requestXrefByVenueXids } from './xrefActions';

const { format } = window;

const receiveMorningstarRatings = response => {
	return ({
		type: Types.API_RECEIVE_MORNINGSTAR_RATINGS,
		response
	});
};

const handleLoader = fetchName => {
	return ({
		type: Types.API_HANDLE_MORNINGSTAR_RATINGS_LOADER,
		fetchName
	});
};

// https://qa-api.markitdigital.com/managedfunds-morningstar-ratingsandrisk/v1/ratings-and-risk/258981?periodTypes=y%2Coverall&periods=3%2C5%2C10&dataPoints=rating

const requestMorningstarRatings = xid => {
	const result = {
		type: Types.API_REQUEST_MORNINGSTAR_RATINGS,
		endPoint: `/managedfunds-morningstar-ratingsandrisk/v1/ratings-and-risk/${xid}`,
		ajaxType: 'GET',
		params: {
			periodTypes: 'y,overall',
			periods: '3,5,10',
			dataPoints: 'rating,riskRating,performanceRating,numberOfDistinctPortfolioInCategory'
		},
		onSuccess: receiveMorningstarRatings,
		on404: receiveMorningstarRatings,
		loader: handleLoader,
		fetchName: 'fetchingMorningstarRatings'
	};

	return result;
};

const receivePremiumDiscountDaily = response => {
	return ({
		type: Types.API_RECEIVE_MORNINGSTAR_PREMIUM_DISCOUNT_DAILY,
		response
	});
};

const requestPremiumDiscountDaily = xid => {
	const result = {
		type: Types.API_REQUEST_MORNINGSTAR_PREMIUM_DISCOUNT_DAILY,
		endPoint: `/managedfunds-morningstar-premiumdiscountdaily/v1/premiumdiscountdaily/${xid}`,
		ajaxType: 'GET',
		onSuccess: receivePremiumDiscountDaily,
		loader: handleLoader,
		fetchName: 'fetchingPremiumDiscountDaily'
	};

	return result;
};

const receiveShareClass = response => {
	return ({
		type: Types.API_RECEIVE_MORNINGSTAR_SHARE_CLASS,
		response
	});
};

const requestShareClass = xid => {
	const result = {
		type: Types.API_REQUEST_MORNINGSTAR_SHARE_CLASS,
		endPoint: `/managedfunds-morningstar-shareclass/v1/share-class/${xid}`,
		ajaxType: 'GET',
		onSuccess: receiveShareClass,
		loader: handleLoader,
		fetchName: 'fetchingShareClass'
	};

	return result;
};

const receivePortfolioStatistics = response => {
	return ({
		type: Types.API_RECEIVE_MORNINGSTAR_PORTFOLIO_STATISTICS,
		response
	});
};

const requestPortfolioStatistics = xid => {
	const result = {
		type: Types.API_REQUEST_MORNINGSTAR_PORTFOLIO_STATISTICS,
		endPoint: `/managedfunds-morningstar-portfoliostats/v1/details/${xid}`,
		ajaxType: 'GET',
		onSuccess: receivePortfolioStatistics,
		loader: handleLoader,
		fetchName: 'fetchingPortfolioStatistics'
	};

	return result;
};

const receiveMorningstarManagedFundsStrategy = response => {
	return ({
		type: Types.API_RECEIVE_MORNINGSTAR_MANAGED_FUNDS_STRATEGY,
		response
	});
};

const requestMorningstarManagedFundsStrategy = xid => {
	const result = {
		type: Types.API_REQUEST_MORNINGSTAR_MANAGED_FUNDS_STRATEGY,
		endPoint: `/managedfunds-morningstar-strategy/v1/details/${xid}`,
		ajaxType: 'GET',
		onSuccess: receiveMorningstarManagedFundsStrategy,
		loader: handleLoader,
		fetchName: 'fetchingManagedFundsStrategy'
	};

	return result;
};

const receiveRiskMeasures = response => {
	return ({
		type: Types.API_RECEIVE_MORNINGSTAR_RISK_MEASURES,
		response
	});
};

const requestRiskMeasures = xid => {
	const result = {
		type: Types.API_REQUEST_MORNINGSTAR_RISK_MEASURES,
		endPoint: `/managedfunds-morningstar-riskmeasures/v1/risk-measures/${xid}`,
		ajaxType: 'GET',
		loader: handleLoader,
		onSuccess: receiveRiskMeasures,
		fetchName: 'fetchingRiskMeasures'
	};

	return result;
};

const receiveMorningstarFundBenchmark = response => {
	return ({
		type: Types.API_RECEIVE_MORNINGSTAR_MANAGED_FUNDS_BENCHMARK,
		response
	});
};

const requestMorningstarFundBenchmark = xid => {
	const result = {
		type: Types.API_REQUEST_MORNINGSTAR_MANAGED_FUNDS_BENCHMARK,
		endPoint: `/managedfunds-morningstar-benchmarkinformation/v1/benchmarks/${xid}`,
		ajaxType: 'GET',
		onSuccess: receiveMorningstarFundBenchmark,
		loader: handleLoader,
		fetchName: 'fetchingManagedFundsBenchmark'
	};

	return result;
};

const receiveMorningstarFundBenchmarkCategory = response => {
	return ({
		type: Types.API_RECEIVE_MORNINGSTAR_MANAGED_FUNDS_BENCHMARK_CATEGORY,
		response
	});
};

const requestMorningstarFundBenchmarkCategory = xid => {
	const result = {
		type: Types.API_REQUEST_MORNINGSTAR_MANAGED_FUNDS_BENCHMARK_CATEGORY,
		endPoint: `/managedfunds-morningstar-benchmarkinformation/v1/categories/${xid}`,
		ajaxType: 'GET',
		onSuccess: receiveMorningstarFundBenchmarkCategory,
		loader: handleLoader,
		fetchName: 'fetchingManagedFundsBenchmark'
	};

	return result;
};

const receiveMorningstarAttributes = response => {
	return ({
		type: Types.API_RECEIVE_MORNINGSTAR_MANAGED_FUNDS_ATTRIBUTES,
		response
	});
};

const requestMorningstarAttributes = xid => {
	const result = {
		type: Types.API_REQUEST_MORNINGSTAR_MANAGED_FUNDS_ATTRIBUTES,
		endPoint: `/managedfunds-morningstar-fundattributes/v1/details/${xid}`,
		ajaxType: 'GET',
		onSuccess: receiveMorningstarAttributes,
		loader: handleLoader,
		fetchName: 'fetchingManagedFundsAttributes'
	};
	return result;
};

const receiveAnnualPerformance = response => {
	return ({
		type: Types.API_RECEIVE_MORNINGSTAR_ANNUAL_PERFORMANCE,
		response
	});
};

const requestAnnualPerformance = xid => {
	const result = {
		type: Types.API_REQUEST_MORNINGSTAR_ANNUAL_PERFORMANCE,
		endPoint: '/managedfunds-morningstar-performanceannual/v1/performance-annual',
		params: {
			venueXid: xid
		},
		ajaxType: 'GET',
		onSuccess: receiveAnnualPerformance,
		loader: handleLoader,
		fetchName: 'fetchingAnnualPerformance'
	};
	return result;
};

const receivePerformance = (response, xid) => {
	return ({
		type: Types.API_RECEIVE_MORNINGSTAR_PERFORMANCE,
		response,
		xid
	});
};

const requestPerformance = xid => {
	const result = {
		type: Types.API_REQUEST_MORNINGSTAR_PERFORMANCE,
		endPoint: `/managedfunds-morningstar-performance/v1/trailing-month-end/${xid}`,
		params: {
			dataPoints: 'marketReturn',
			periodTypes: 'ytd'
		},
		ajaxType: 'GET',
		onSuccess: response => { return receivePerformance(response, xid); },
		loader: handleLoader,
		fetchName: 'fetchingPerformance'
	};
	return result;
};
const receiveMorningstarPeers = response => {
	const actions = [];
	const venueXids = [];
	if (response && response.data && response.data.items) {
		response.data.items.forEach(item => {
			if (item.venueXid) {
				actions.push(requestPerformance(item.venueXid));
				venueXids.push(item.venueXid);
			}
		});
	}
	actions.push(requestXrefByVenueXids(venueXids));
	actions.push({
		type: Types.API_RECEIVE_MORNINGSTAR_PEERS,
		response
	});

	return actions;
};

const requestMorningstarPeers = xid => {
	const result = {
		type: Types.API_REQUEST_MORNINGSTAR_PEERS,
		endPoint: `/managedfunds-morningstar-peers/v1/details/${xid}`,
		params: {
			newInvestors: 'openOnly',
			numberOfResults: 10,
			shareClassType: 'sameShareClassOnly'
		},
		ajaxType: 'GET',
		onSuccess: receiveMorningstarPeers,
		loader: handleLoader,
		fetchName: 'fetchingMorningstarPeers'
	};
	return result;
};

const receiveMorningStarGrowth10k = response => {
	return ({
		type: Types.API_RECEIVE_MORNINGSTAR_GROWTH_10K,
		response
	});
};

const requestMorningstarGrowth10k = xid => {
	const result = {
		type: Types.API_REQUEST_MORNINGSTAR_GROWTH_10K,
		endPoint: `/managedfunds-morningstar-growthof10k/v2/growth-of-10k/${xid}`,
		ajaxType: 'GET',
		onSuccess: receiveMorningStarGrowth10k,
		loader: handleLoader,
		fetchName: 'fetchingManagedFundsGrowth10k'
	};

	return result;
};

const receiveAssetAllocationData = response => {
	return ({
		type: Types.API_RECEIVE_MORNINGSTAR_ASSET_ALLOCATION,
		response
	});
};

const requestMorningstarAssetAllocationData = xid => {
	const result = {
		type: Types.API_REQUEST_MORNINGSTAR_ASSET_ALLOCATION,
		endPoint: `managedfunds-morningstar-assetallocation/v1/asset-allocation/${xid}`,
		ajaxType: 'GET',
		onSuccess: receiveAssetAllocationData,
		loader: handleLoader,
		fetchName: 'fetchingAssetAllocationData'
	};
	return result;
};

const receiveTopHoldings = response => {
	format.removeUtcTimezoneFromPropertyOnCollection(get(response, 'data.items'), 'holdingDetailDate');
	return ({
		type: Types.API_RECEIVE_MORNINGSTAR_TOP_HOLDINGS,
		response
	});
};

const requestTopHoldings = xid => {
	const result = {
		type: Types.API_REQUEST_MORNINGSTAR_TOP_HOLDINGS,
		// type: Types.API_CIBC_REQUEST_MORNINGSTAR_TOP_HOLDINGS,
		endPoint: `managedfunds-morningstar-topholdings/v1/topHoldings/${xid}`,
		// endPoint: `topHoldings/${xid}`,
		ajaxType: 'GET',
		onSuccess: receiveTopHoldings,
		loader: handleLoader,
		fetchName: 'fetchingTopHoldings'
	};
	return result;
};

const receiveSectorAllocation = response => {
	return ({
		type: Types.API_RECEIVE_MORNINGSTAR_SECTOR_ALLOCATION,
		response
	});
};

const requestSectorAllocation = xid => {
	const result = {
		type: Types.API_REQUEST_MORNINGSTAR_SECTOR_ALLOCATION,
		endPoint: `managedfunds-morningstar-sectorallocation/v1/sector-allocation/${xid}`,
		ajaxType: 'GET',
		onSuccess: receiveSectorAllocation,
		loader: handleLoader,
		fetchName: 'fetchingSectorAllocationData'
	};
	return result;
};

const receiveMorningstarCompanyInformation = response => {
	return ({
		type: Types.API_RECEIVE_MORNINGSTAR_COMPANY_INFORMATION,
		response
	});
};

const requestMorningstarCompanyInformation = xid => {
	const result = {
		type: Types.API_REQUEST_MORNINGSTAR_COMPANY_INFORMATION,
		endPoint: `/managedfunds-morningstar-companyinformation/v1/company-information/${xid}`,
		ajaxType: 'GET',
		onSuccess: receiveMorningstarCompanyInformation,
		loader: handleLoader,
		fetchName: 'fetchingMorningstarCompanyInformation'
	};
	return result;
};

const receiveMorningstarFundDetails = response => {
	return ({
		type: Types.API_CIBC_RECEIVE_MORNINGSTAR_FUND_DETAILS,
		response
	});
};

const requestMorningstarFundDetails = xids => {
	const xidsArray = xids || [];
	const xidString = xidsArray.join(',');

	const result = {
		type: Types.API_CIBC_REQUEST_MORNINGSTAR_FUND_DETAILS,
		endPoint: '/morningstar/funddetail',
		params: {
			xids: xidString
		},
		ajaxType: 'GET',
		onSuccess: receiveMorningstarFundDetails,
		loader: handleLoader,
		fetchName: 'fetchingMorningstarFundDetails'
	};
	return result;
};

const recieveMorningstarAnnualReturnData = response => {
	return ({
		type: Types.API_RECIEVE_MORNINGSTAR_ANNUAL_RETURN_DATA,
		response
	});
};

const requestMorningstarAnnualReturnData = xid => {
	const result = {
		type: Types.API_REQUEST_MORNINGSTAR_ANNUAL_RETURN_DATA,
		endPoint: `managedfunds-morningstar-performance/v1/trailing-month-end/${xid}`,
		params: {
			periodTypes: 'm,y,ytd',
			periods: '1,3,5,6,10',
			dataPoints: 'marketReturn,return,returnCategoryRank,returnCategorySize'
		},
		ajaxType: 'GET',
		onSuccess: recieveMorningstarAnnualReturnData,
		loader: handleLoader,
		fetchName: 'fetchingMorningstarAnnualReturn'
	};
	return result;
};

const receiveMorningstarProspectusFees = response => {
	return ({
		type: Types.API_RECEIVE_MORNINGSTAR_PROSPECTUS_FEES,
		response
	});
};

const requestMorningstarProspectusFees = xid => {
	const result = {
		type: Types.API_REQUEST_MORNINGSTAR_PROSPECTUS_FEES,
		endPoint: `managedfunds-morningstar-prospectusfees/v1/prospectus-fees/${xid}`,
		ajaxType: 'GET',
		onSuccess: receiveMorningstarProspectusFees,
		loader: handleLoader,
		fetchName: 'fetchingMorningstarProspectusFees'
	};
	return result;
};

const recieveMorningstarTopHoldings = response => {
	const action = [];
	const xids = [];
	if (response && response.data && response.data.fundList) {
		response.data.fundList.forEach(fund => {
			if (fund.venueXid) {
				xids.push(fund.venueXid);
			}
		});
	}
	action.push(requestXrefByVenueXids(xids));
	action.push({
		type: Types.API_CIBC_RECEIVE_TOP_HOLDINGS,
		response
	});

	return action;
};

const requestMorningstarTopHoldings = (venueXid, rowStart) => {
	if (venueXid === null) {
		return {
			type: Types.API_CLEAR_TOP_HOLDINGS
		};
	}

	const result = {
		type: Types.API_CIBC_REQUEST_TOP_HOLDINGS,
		endPoint: `/morningstar/topHoldings/${venueXid}`,
		params: {
			rowStart
		},
		ajaxType: 'GET',
		onSuccess: recieveMorningstarTopHoldings,
		loader: handleLoader,
		fetchName: 'fetchingMorningstarTopHoldings'
	};
	return result;
};

const receiveMorningstarAnnualFees = response => {
	return ({
		type: Types.API_RECEIVE_MORNINGSTAR_ANNUAL_FEES,
		response
	});
};

const requestMorningstarAnnualFees = (venueXid, responseHandler) => {
	const result = {
		type: Types.API_REQUEST_MORNINGSTAR_ANNUAL_FEES,
		endPoint: `managedfunds-morningstar-annualfees/v1/details/${venueXid}`,
		ajaxType: 'GET',
		onSuccess: responseHandler || receiveMorningstarAnnualFees,
		loader: handleLoader,
		fetchName: 'fetchingMorningstarAnnualFees'
	};

	return result;
};

export {
	requestMorningstarRatings,
	receiveMorningstarRatings,
	requestPremiumDiscountDaily,
	requestShareClass,
	requestPortfolioStatistics,
	requestMorningstarManagedFundsStrategy,
	requestMorningstarFundBenchmark,
	requestMorningstarFundBenchmarkCategory,
	requestMorningstarAttributes,
	requestRiskMeasures,
	requestMorningstarPeers,
	requestAnnualPerformance,
	requestPerformance,
	requestMorningstarGrowth10k,
	requestMorningstarAssetAllocationData,
	requestSectorAllocation,
	requestTopHoldings,
	requestMorningstarAnnualReturnData,
	handleLoader,
	requestMorningstarCompanyInformation,
	requestMorningstarFundDetails,
	requestMorningstarProspectusFees,
	requestMorningstarTopHoldings,
	requestMorningstarAnnualFees,
	receiveMorningstarAnnualFees
};
